import { ContentPanel } from '@/components/content-panel';
import { useCurrentUserQuery } from '@/hooks/use-current-user/graphql.generated';
import { Flex, Text, Title } from '@mantine/core';
import styles from './styles.module.css';

export const UnauthorisedPage = () => {
	const { data } = useCurrentUserQuery({ skip: true });

	return (
		<Flex className={styles.content}>
			<ContentPanel>
				<Title order={1}>{`Hi ${data?.currentUser?.contact?.firstName ?? 'there!'}`}</Title>
				<Text>
					Your account is not authorised to access this application. Please reach out to Curby
					support.
				</Text>
			</ContentPanel>
		</Flex>
	);
};
